module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de_at":{"save":"Speichern","cancel":"Abbrechen"},"cs":{"save":"Uložit","cancel":"zrušení"},"hu":{"save":"mentés","cancel":"megszünteti"},"fr":{"save":"enregistrer","cancel":"Annuler"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/rating/Field.vue
// module id = 1094
// module chunks = 0